module.exports = __webpack_public_path__ + "static/media/1.85c4139f.png";